<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row no-gutters>
        <v-col>
          <v-card class="pa-2 ma-2" outlined tile>
            <!-- toolbar -->
            <reference-tool-bar
              :title="options.title.main"
              :editedIndex="editedIndex"
              :createItemTitle="options.title.create"
              :formTitle="formTitle"
              :dialog="dialog"
              @save="save"
              @close="close"
              @open="open"
            >
              <template v-slot:formCreateEdit>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.name"
                    label="Наименование"
                    :hint="`Введите тип устройства`"
                    :rules="[rules.min, rules.alfabet]"
                    autofocus
                  >
                  </v-text-field>
                </v-flex>
              </template>
            </reference-tool-bar>
            <!--Таблица с данными-->
            <reference-table
              :headers="options.headers"
              :items="options.data"
              @edit-item="editItem($event)"
              @remove-item="removeItem($event)"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { get } from "vuex-pathify";
import { mapActions } from "vuex";
import { rules } from "@/util/rules";
import { getCurrentLoggedUserRole } from "@/util/helpers";

export default Vue.extend({
  name: "Device.vue",
  components: {
    ReferenceTable: () => import("@/components/reference/ReferenceTable.vue"),
    ReferenceToolBar: () =>
      import("@/components/reference/ReferenceToolBar.vue")
  },
  computed: {
    options: get("reference/optionsDevice"),
    formTitle() {
      return this.editedIndex === -1 ? "Создать" : "Редактировать";
    }
  },
  data() {
    return {
      currentLoggedUserRole: "",
      rules,
      dialog: false,
      allowedActionsRoles: ["admin", "manager"],
      editedIndex: -1
    };
  },
  methods: {
    ...mapActions({
      fetchReference: "reference/fetchDevice"
    }),
    async initialize() {
      await this.fetchReference();
      this.currentLoggedUserRole = getCurrentLoggedUserRole();
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.options.editedItem = Object.assign({}, this.options.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      const model = {
        id: this.options.editedItem.id,
        name: this.options.editedItem.name
      };
      if (this.editedIndex > -1) {
        this.$http.put(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      } else {
        model.id = 0;
        this.$http.post(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      }
      this.close();
    },
    editItem(item) {
      this.editedIndex = this.options.data.indexOf(item);
      this.options.editedItem = Object.assign({}, item);
      this.open();
    },
    removeItem(item) {
      console.log("Удаление через веб-интерфейс не предусмотрено");
      // if (confirm("Are you sure you want to delete this item?")) {
      //   const model = Object.assign({}, item);
      // По договоренности сущности не удаляются, им присваивается статус
      // Для устройств в БД статусы не реализовали пока
      // this.$http
      //   .delete(this.options.path.base, { data: model })
      //   .then((response) => {
      //     if (response.status === "Ok") this.initialize();
      //   });
      // }
    }
  },
  async created() {
    await this.initialize();
  }
});
</script>
